<template>
    <div class="increment">
        <IconMinus size="20" :color="total === 1 ? 'var(--secondary-color)' : '#0B9CEA'" @click="changeNumber(-1)" />
        <span class="increment__number">{{total}}</span>
        <IconPlus size="20" :color="total >= tope ? 'var(--secondary-color)' : '#0B9CEA'" @click="changeNumber(1)"/>
    </div>
</template>

<script setup>  

    import {ref, computed, watch} from 'vue';
    import { IconPlus,IconMinus } from '@tabler/icons-vue';

    const emit = defineEmits(['update:total']);

    const props = defineProps({
        // Las plazas que quedan a la hora elegida. Sin hora todavia, las cuatro
        // de siempre: no hay contra que acotar y no es momento de estorbar.
        max: { type: Number, default: 4 },
        // Lo que el padre dice que vale. Existe para que una correccion suya se
        // VEA aqui: antes el padre bajaba el numero y este seguia ensenando el
        // que el visitante habia elegido.
        valor: { type: Number, default: 1 }
    });

    const total = ref(props.valor);

    /*
     * EL CUATRO SE FUE DE AQUI, y es el cambio de hoy.
     *
     * Estaba a fuego en el frontal heredado -`total + number <= 4`- y se
     * conservo al poner el tope por plazas, por no cambiar dos cosas a la
     * vez. Pero es un numero que no sabe nada: la ficha de la experiencia
     * ya dice cuanta gente admite una reserva, se puede configurar de 1 a
     * 100, y el servidor rechaza por ESE numero. Un cuatro aqui tapaba el
     * que valia, para arriba y para abajo.
     *
     * El cuatro sigue existiendo como ultimo recurso, pero ahora lo decide
     * quien tiene los datos -`topeDeAsistentes()` en ExperienceView- y no
     * este componente, que no tiene forma de saberlo.
     */
    const tope = computed(() => Math.max(1, props.max ?? 4));

    watch(() => props.valor, (nuevo) => { total.value = Math.max(1, nuevo || 1); });

    const changeNumber = (number) => {
        if (total.value + number >= 1 && total.value + number <= tope.value) {
            total.value += number;
            emit('update:total', total.value);
        }
    };

</script>


<style lang="scss">

    @import '@/scss/mixings';

    .increment{
        @include d-flex(row,space-between,center);
        padding: 5px;
        gap: 5px;
        width: 100px;
        height: 40px;
        border-radius: 8px;
        border: 2px solid var(--border, #DDD);
        background: var(--backgroundContainer, #FFF);
        cursor: pointer;
        &__number{
            font-size: 16px;
            color: #0B2739;
        }
    }

</style>